<template>
  <div class="py-3 px-5 text-left bg-red-300 border rounded-md text-xs">
    <strong>Warning: This is the demo Mode (Stripe/Braintree Sandbox)</strong>
    <ul class="my-1">
      <li>Card Number : 4111 1111 1111 1111</li>
      <li>Expiration Date : 05/29</li>
      <li>CVV : 258</li>
    </ul>
    <p class="text-red">
      Don't use your original card data while the demo mode ,use only above information or click
      <a
        class="text-blue-800"
        href="https://developer.paypal.com/braintree/docs/guides/credit-cards/testing-go-live/php#test-value-378282246310005"
        rel="noopener"
        target="_blank"
        title="See the list of test cards for braintree sandbox in demo mode"
        >here for braintree</a
      >
      and
      <a class="text-blue-800" href="https://stripe.com/docs/testing" rel="noopener" target="_blank" title="See the list of test cards for strip sandbox in demo mode"
        >here for stripe</a
      >
      to see full list of available test cards with different scenarios.
    </p>
  </div>
</template>
<script>
export default {
  name: 'demo-note',
};
</script>
